import React from 'react';


import LeftArrowIcon from '@material-ui/icons/KeyboardArrowLeft';
import RightArrowIcon from '@material-ui/icons/KeyboardArrowRight';
import CalendarToday from '@material-ui/icons/DateRange';
import Alarm from '@material-ui/icons/Alarm';


import {
  KeyboardDateTimePicker,
  MuiPickersUtilsProvider,
} from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import ptBR from 'date-fns/locale/pt-BR';


const CustomDateTimePicker = props => (
  <MuiPickersUtilsProvider utils={DateFnsUtils} locale={ptBR}>
    <KeyboardDateTimePicker
      {...props}
      keyboard
      // mask={[/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/, ' ', ' ', /\d/, /\d/, ':', /\d/, /\d/]}
      mask="__/__/____ __:__"
      ampm={false}
      invalidDateMessage="Data inválida"
      placeholder="dd/mm/aaaa hh:mm"
      format="dd/MM/yyyy HH:mm"
      leftArrowIcon={<LeftArrowIcon />}
      rightArrowIcon={<RightArrowIcon />}
      keyboardIcon={<CalendarToday />}
      dateRangeIcon={<CalendarToday />}
      timeIcon={<Alarm />}
      disableOpenOnEnter
      animateYearScrolling
      required
      cancelLabel="Cancelar"
      okLabel="Confirmar"
      minDateMessage="Data final deve ser maior a data inicial"
      maxDateMessage="Data inicial deve ser menor que a data final"
    />
  </MuiPickersUtilsProvider>
);

export default CustomDateTimePicker;
